const API_BASE = import.meta.env.VITE_API_BASE ?? "http://localhost:3101";

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(init.headers ?? {}),
    },
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status} ${body}`);
  }
  return res.json() as Promise<T>;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: "POST", body: body ? JSON.stringify(body) : undefined }),
  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: "PATCH", body: body ? JSON.stringify(body) : undefined }),
  del: <T>(path: string) => request<T>(path, { method: "DELETE" }),
};

export interface Me {
  role: "FORMATEUR";
  formateur: {
    id: string;
    email: string;
    displayName: string;
    stripeOnboardingComplete: boolean;
  };
  espace: { id: string; slug: string; name: string };
}

export type AssetKind = "VIDEO" | "AUDIO" | "PDF" | "IMAGE";

export interface Asset {
  id: string;
  kind: AssetKind;
  name: string;
  sizeBytes: number | null;
  mimeType: string | null;
  durationSec: number | null;
  width: number | null;
  height: number | null;
  bunnyVideoId: string | null;
  cdnUrl: string | null;
  thumbnailUrl: string | null;
  isReady: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface InitUploadResp {
  asset: Asset;
  upload: {
    provider: "bunny" | "r2";
    url: string;
    headers: Record<string, string>;
    dev: boolean;
  };
}
